var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpEdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 21.5C14.28 21.5 16.0201 20.9722 17.5001 19.9832C18.9802 18.9943 20.1337 17.5887 20.8149 15.9442C21.4961 14.2996 21.6743 12.49 21.3271 10.7442C20.9798 8.99836 20.1226 7.39472 18.864 6.13604C17.6053 4.87737 16.0016 4.0202 14.2558 3.67294C12.51 3.32567 10.7004 3.5039 9.05585 4.18509C7.41131 4.86628 6.00571 6.01983 5.01677 7.49987C4.02784 8.97991 3.5 10.72 3.5 12.5C3.5 13.988 3.86 15.391 4.5 16.627L3.5 21.5L8.373 20.5C9.609 21.14 11.013 21.5 12.5 21.5Z",
    stroke: "#6A4E42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpEdIcon);
export default __webpack_public_path__ + "static/media/op-ed-icon.13dca6b81a3d7e501ec6301a2d8d5909.svg";
export { ForwardRef as ReactComponent };